<template>
  <div>
    <TheAppBar />
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import TheAppBar from '@/components/home/TheAppBar'

// Helpers
import api from '@/api'
import { requestFirebaseNotificationPermission } from '@/utils/firebase'

export default {
  name: 'Home',

  components: {
    TheAppBar,
  },

  mounted() {
    this.activateNotifications()
  },

  methods: {
    activateNotifications() {
      requestFirebaseNotificationPermission()
        .then(async firebaseToken => {
          console.log(`> Firebase Token: ${firebaseToken}`)
          try {
            await api.notifications.saveFcmToken({
              data: { fcm_token: firebaseToken },
            })
          } catch (err) {
            console.error(err)
          }
        })
        .catch(err => {
          console.error(`> Error generating firebase token: ${err}`)
        })
    },
  },
}
</script>
